import { useState, useCallback } from 'react'
import { mergeDatesWithAvailability } from '@abroad/rest-client'
import API from '../../../utils/API'

export const useSlotAvailability = (coachId, sowSessionDuration, sowId) => {
  const [isCheckingAvailability, setIsCheckingAvailability] = useState(false)

  const checkSlotAvailabilityForDates = useCallback(
    async (dates) => {
      if (!coachId || !dates || dates.length === 0) {
        return []
      }

      try {
        setIsCheckingAvailability(true)

        const selectedSlots = dates.map((dateItem) => dateItem.slotStart)

        const payload = {
          selectedSlots,
          sowSessionDuration: sowSessionDuration || 0,
          sowId,
        }

        const { data } = await API.ClientAPI.session.checkSlotAvailability(
          coachId,
          payload,
        )

        if (data?.success && Array.isArray(data.data)) {
          return mergeDatesWithAvailability(dates, data.data)
        }

        return dates
      } catch (error) {
        throw error
      } finally {
        setIsCheckingAvailability(false)
      }
    },
    [coachId, sowSessionDuration, sowId],
  )

  return { checkSlotAvailabilityForDates, isCheckingAvailability }
}
